module.exports = __webpack_public_path__ + "static/media/01-07.84b0066a.mp3";